export default __webpack_public_path__ + "static/color-analysis-contrast-a8783c28c66b96ce4ccca07a29e152ef.jpg";